import { ProjectsContext } from '@contexts/ProjectsContext/ProjectsContext'
import { useContext } from 'react'

const useProjects = () => useContext(ProjectsContext)

export default useProjects
